import { FactoryFormsModule } from '@b2b/common/factories/forms/forms.factory';
import { GridStateFactory } from '@b2b/common/factories/gridState/types';
import { NoticeFactory } from '@b2b/common/factories/notice';
import { ApiService } from '@b2b/common/services/api/types';
import { CalendarService } from '@b2b/common/services/calendar';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { UserPreferencesService } from '@b2b/common/services/userPreferences/types';
import { ColumnDef, ContentHeaderProps, TODO, UIBModalService } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, ILogService, IQService, ISCEService, IScope, ITimeoutService } from 'angular';

ProgramsInstanceController.$inject = [
  '$scope',
  '$state',
  '$filter',
  '$sce',
  '$log',
  '$uibModal',
  '$timeout',
  '$q',
  'ApiService',
  'CalendarService',
  'HelpersService',
  'TemplatesService',
  'TemplatesHelpersService',
  'AuthService',
  'DiscountCodesData',
  'UserPreferencesService',
  'FormsFactory',
  'NoticeFactory',
  'GridStateFactory',
  'EventInstance',
  'ThemesHelperService',
];

function ProgramsInstanceController(
  $scope: IScope & {
    programsInstance: TODO;
    ordersGridOptions: TODO;
    pricingGridOptions: {
      enableRowSelection: boolean;
      paginate: boolean;
      multiSelect: boolean;
      showFooter: boolean;
      columnDefs: ColumnDef[];
    };
    resourcesGridOptions: TODO;
    appScopeProvider: TODO;
  },
  $state: StateService,
  $filter: IFilterService,
  $sce: ISCEService,
  $log: ILogService,
  $uibModal: UIBModalService,
  $timeout: ITimeoutService,
  $q: IQService,
  ApiService: ApiService,
  CalendarService: CalendarService,
  HelpersService: TODO,
  TemplatesService: TODO,
  TemplatesHelpersService: TODO,
  AuthService: TODO,
  DiscountCodesData: TODO,
  UserPreferencesService: UserPreferencesService,
  FormsFactory: TODO,
  NoticeFactory: NoticeFactory,
  GridStateFactory: GridStateFactory,
  EventInstance: TODO,
  ThemesHelperService: ThemesHelperService
) {
  const ctrl = {
    model: {} as TODO,
    componentType: 'event',
    primaryPhoto: {},
    ownerId: false,
    isUserEvent: false,
    isCancelled: false,
    isSuspended: false,
    safeDescription: '',
    orders: [] as TODO[],
    currentTab: 'description',
    templateName: '',
    priceListName: '',
    isPriceListEdited: false,
    hasAppliedAddOns: false,
    currentForm: false as TODO | false,
    editor: {} as TODO,
    previewContainer: false,
    entity: null as TODO,

    notice: new NoticeFactory(),
    gridState: new GridStateFactory(),

    resourcesList: [] as TODO[],

    discountCodes: [] as TODO[],
    resourceRequests: [] as TODO[],
    preferences: new FormsFactory().getDefaultObjectPreferences(),

    cap: HelpersService.cap,
    strip: HelpersService.strip,

    admissionTypes: TemplatesHelpersService.getAdmissionTypes(),
    flexpayTypes: TemplatesHelpersService.getFlexpayTypes(),
    getFlexpayType: TemplatesHelpersService.getFlexpayType,
    loadedDateFormats: false,

    standardTime: '',
    extendedDate: '',
    dateTimeFormat: HelpersService.dateFormats.standardTime + ', ' + HelpersService.dateFormats.extendedDate,
    ordersDateFormat: '',
    formattedCancellationDate: '',
    enableSalesTax: false,

    init: function () {
      ctrl.enableSalesTax = ThemesHelperService.getFeatureFlag('enableSalesTax');

      if (ctrl.enableSalesTax) {
        const priceColumnIndex = $scope.pricingGridOptions.columnDefs.findIndex((column) => column.field === 'price');

        /**
         * Insert after `basePrice` after `price` column
         */
        $scope.pricingGridOptions.columnDefs.splice(priceColumnIndex + 1, 0, {
          field: 'basePrice',
          displayName: 'Base Price',
          cellFilter: 'basePrice',
        });
      }

      // Title set in return ctrl.success.getInstance() -> ctrl.updateHeader()
      if (AuthService.hasRole('personnel')) {
        ctrl.ownerId = AuthService.getCookie('user').id;
      }

      if (DiscountCodesData.data && DiscountCodesData.data.success) {
        ctrl.success.getDiscounts(DiscountCodesData);
      } else {
        ctrl.error.getDiscounts(DiscountCodesData);
      }

      ctrl.getEntity($state.params.id);
      ctrl.getPublishedEventTemplate(EventInstance);
      ctrl.getOrders($state.params.id);
      ctrl.standardTime = UserPreferencesService.getDateFormat('standardTime', 'hourFormat');
      ctrl.extendedDate = UserPreferencesService.getDateFormat('extendedDate', 'dateFormat');
      ctrl.ordersDateFormat = UserPreferencesService.getDateTimeFormat('shortDateTime');

      $scope.$watch('programsInstance.currentTab', ctrl.onCurrentTabChanged);
    },

    findAdmissionType: function (name) {
      let r: TODO | false = false;

      for (let i = 0, ii = ctrl.admissionTypes.length; i < ii; i++) {
        if (ctrl.admissionTypes[i].name === name) {
          r = ctrl.admissionTypes[i];
          break;
        }
      }

      return r;
    },

    findDiscount: function (id) {
      let r: TODO | false = false;

      for (let i = 0, ii = ctrl.discountCodes.length; i < ii; i++) {
        if (ctrl.discountCodes[i].id === id) {
          r = ctrl.discountCodes[i];
          break;
        }
      }

      return r;
    },

    findFlexpayType: function (type) {
      return TemplatesHelpersService.getFlexpayType(TemplatesHelpersService.getFlexpayTypes(), type);
    },

    getEntity: function (id) {
      ApiService.entity.schedules
        .event(id)
        .then((response) => ctrl.success.getEntity(response))
        .catch((response) => ctrl.error.getEntity(response));
    },

    getDiscounts: function () {
      ApiService.discounts
        .list('v2', HelpersService.getPaginator())
        .then((response) => ctrl.success.getDiscounts(response))
        .catch((response) => ctrl.error.getDiscounts(response));
    },

    getPublishedEventTemplate: function (response) {
      ctrl.success.getInstance(response);
      if (ctrl.model.templateId) {
        ApiService.program.template
          .published({ eventTemplateId: ctrl.model.templateId })
          .then((response) => ctrl.success.getPublishedEventTemplate(response))
          .catch((response) => ctrl.error.getPublishedEventTemplate(response));
      }
    },

    getPriceListName: function (id) {
      ApiService.price.lists
        .detail(id)
        .then((response) => ctrl.success.getPriceListName(response))
        .catch((response) => ctrl.error.getPriceListName(response));
    },

    getOrders: function (id) {
      ApiService.orders
        .event(id)
        .then((response) => ctrl.success.getOrders(response))
        .catch((response) => ctrl.error.getOrders(response));
    },

    getResourceRequests: function () {
      const props = $.extend({ eventId: $state.params.id }, ctrl.gridState.getGridState());

      ApiService.program.resources.requests
        .list(props)
        .then((response) => ctrl.success.getResourceRequests(response))
        .catch((response) => ctrl.error.getResourceRequests(response));
    },

    getScheduleTime: function (time) {
      const ampm = time.hour >= 0 && time.hour < 11 ? 'am' : 'pm';
      return CalendarService.toHour(time.hour) + ':' + CalendarService.toMinutes(time.minutes) + ampm;
    },

    getWeekdays: function (weekdays) {
      let days = '';

      for (let i = 0, ii = weekdays.length; i < ii; i++) {
        if (i > 0) {
          if (i === ii - 1) {
            days += ', and ';
          } else if (i <= ii - 2) {
            days += ', ';
          }
        }
        days += CalendarService.weekdays[weekdays[i]].name;
      }

      return days;
    },

    getScheduleStartDate: function () {
      return HelpersService.getEth($filter('date')(ctrl.model.startTime, 'd'));
    },

    getScheduleEndDate: function () {
      return HelpersService.getEth($filter('date')(ctrl.model.endTime, 'd'));
    },

    getTotalOrders: function () {
      return ctrl.orders.length;
    },

    getSalesChannel: function () {
      let r = '';
      const channels: string[] = [];
      let allEnabled = true;

      if (ctrl.model.salesChannels.length) {
        ctrl.model.salesChannels.forEach(function (item) {
          if (item.enabled) {
            channels.push(item.name);
          } else {
            allEnabled = false;
          }
        });

        if (channels.length) {
          r = channels.join(', ');
        } else {
          r = 'None';
        }

        if (allEnabled && channels.length) {
          r = 'All';
        }
      }

      return r;
    },

    updateHeader: function () {
      const contentTitle: ContentHeaderProps = {
        title: (ctrl.model.type && ctrl.model.type === 'private' ? 'Private ' : '') + 'Event Details',
        buttonLeft: {
          label: '< Back',
          action: function () {
            window.history.go(-1);
          },
        },
      };

      contentTitle.buttonRight = {
        permissions: ['EVENT_UPDATE'],
        label: 'Edit Event',
        action: function () {
          $state.go('application.programsInstanceEdit', { id: $state.params.id });
        },
      };

      $scope.$emit('Application::contentTitleChange', contentTitle);
    },

    updateRsvp: function (state) {
      if (ctrl.entity) {
        ctrl.entity.rsvpState = state;

        ApiService.entity.schedules
          .rsvp({
            id: ctrl.entity.id,
            rsvpState: ctrl.entity.rsvpState,
          })
          .then((response) => {
            // noop
          })
          .catch((response) => {
            // noop
          });
      }
    },

    assign: function (item) {
      const self = $scope.programsInstance;
      if (AuthService.hasPermission(['RESOURCES_REQUESTS_ASSIGN', 'RESOURCES_REQUESTS_SELF_ASSIGN'])) {
        const showModal = $uibModal.open<TODO>({
          templateUrl: 'views/application/views/resources/modals/assign/assign.tpl.html',
          size: 'lg',
          controller: 'ResourcesModalsAssignController',
          resolve: {
            request: () => item,
          },
        });

        showModal.result
          .then((resourceRequest) => {
            let found;
            const startTime = CalendarService.parseDate(resourceRequest.resourceStartTime);
            const endTime = CalendarService.parseDate(resourceRequest.resourceEndTime);
            resourceRequest.timeSlot = ctrl.getDateRange(startTime, endTime);
            resourceRequest.eventScheduleDisplayName =
              resourceRequest.eventName +
              (resourceRequest.eventScheduleName ? '-' + resourceRequest.eventScheduleName : '');

            if (resourceRequest.id) {
              found = self.findRequest(resourceRequest.id); // TODO: where is this function defined?

              if (found) {
                ctrl.model[found.index] = resourceRequest;
              }
            } else {
              ctrl.model.push(resourceRequest);
            }
          })
          .catch(() => {
            // noop
          });
      } else {
        $scope.$emit('Permissions::error');
      }
    },

    rescheduleEvent: function () {
      ctrl.notice.hideErrorMessages();

      if (ctrl.showRescheduleEvent()) {
        const rescheduleEventModal = $uibModal.open<TODO>({
          templateUrl: 'views/application/views/programs/modals/rescheduleEvent/rescheduleEvent.tpl.html',
          size: 'md',
          controller: 'ProgramsModalsRescheduleEventController',
          resolve: {
            eventInstance: () => ctrl.model,
            resourcesCount: () => (Array.isArray(ctrl.model.resources) ? ctrl.model.resources.length : 0),
            resourcesList: () => ctrl.resourcesList,
            template: () => ApiService.program.get(ctrl.model.templateId, true),
          },
        });

        rescheduleEventModal.result.then(function (rescheduledEvent) {
          ApiService.program.times
            .update(rescheduledEvent)
            .then(function (res) {
              const allProps: TODO[] = [];

              ctrl.success.rescheduleEvent(res);

              angular.forEach(rescheduledEvent.selectedResourcesList, function (item, id) {
                const props = {
                  resourceRequestId: id,
                  sendEmail: true,
                } as TODO;

                if (item) {
                  props.resourceId = item;
                  props.notificationEmail = true;
                }

                allProps.push(props);
              });

              // we need to save resources one by one
              allProps
                .reduce((promise, props) => {
                  return promise.then(() => {
                    return props.hasOwnProperty('resourceId')
                      ? ApiService.resource.assignment.assign(props)
                      : ApiService.resource.assignment.unassign(props);
                  });
                }, $q.when(null))
                .then(() => {
                  // noop
                })
                .catch(() => {
                  ctrl.notice.showErrorMessages(
                    [
                      {
                        message:
                          'something wrong happened when the resource requests were being saved. Please try again.',
                      },
                    ],
                    { duration: 3000 }
                  );
                });
            })
            .catch((response) => ctrl.error.rescheduleEvent(response));
        });
      }
    },

    isTab: function (tab) {
      return tab === ctrl.currentTab;
    },

    getTab: function (tab) {
      ctrl.currentTab = tab;
    },

    isAccepted: function () {
      return ctrl.entity.rsvpState && ctrl.entity.rsvpState === 'Accepted';
    },

    isDeclined: function () {
      return ctrl.entity.rsvpState && ctrl.entity.rsvpState === 'Declined';
    },

    isPending: function () {
      return ctrl.entity.rsvpState && ctrl.entity.rsvpState === 'Pending';
    },

    hasFlexpays: function () {
      return Array.isArray(ctrl.model.flexPays) && ctrl.model.flexPays.length;
    },

    hasPriceLists: function () {
      return ctrl.model.priceList && ctrl.model.priceList.prices && ctrl.model.priceList.prices.length;
    },

    hasTicketConfigs: function () {
      return ctrl.model.ticketConfig && ctrl.model.ticketConfig.printerConfigs.length;
    },

    hasResources: function () {
      return Array.isArray(ctrl.model.resources) && ctrl.model.resources.length;
    },

    findOwner: function (resources) {
      let r: TODO | false = false;

      if (Array.isArray(resources)) {
        for (let i = 0, ii = resources.length; i < ii; i++) {
          if (resources[i].scheduleOwnerId == ctrl.ownerId) {
            r = resources[i];
            break;
          }
        }
      }

      return r;
    },

    onGridDblClick: function (item) {
      $state.go('application.orders.detail.summary', { id: $state.params.id, orderId: item.entity.id });
    },

    getPriceListMap: function (list) {
      return list.map(function (priceObject) {
        return {
          personType: priceObject.personType,
          price: parseInt(priceObject.price, 10),
          saleChannel: priceObject.saleChannel,
        };
      });
    },

    processResourceRequests: function (requests) {
      for (let i = 0, ii = requests.length; i < ii; i++) {
        const startTime = CalendarService.parseDate(requests[i].resourceStartTime);
        const endTime = CalendarService.parseDate(requests[i].resourceEndTime);
        requests[i].timeSlot = ctrl.getDateRange(startTime, endTime);
        requests[i].eventScheduleDisplayName = requests[i].eventName + '-' + requests[i].eventScheduleName;
      }

      return requests;
    },

    getDateRange: function (start, end) {
      let r = $filter('date')(CalendarService.parseDate(start), HelpersService.dateFormats.shortDateTime);

      if (end) {
        r += ' - ';
        r += $filter('date')(CalendarService.parseDate(end), HelpersService.dateFormats.shortDateTime);
      } else {
        r += ' - Indefinite';
      }

      return r;
    },

    previewForm: function () {
      new FormsFactory().previewForm({
        formId: ctrl.model.orderForms[0].id,
        eventName: ctrl.model.name,
        eventStartTime: ctrl.model.oStartTime,
        eventEndTime: ctrl.model.oEndTime,
      });
    },

    showForm: function (forms) {
      if (forms && Array.isArray(forms) && forms.length) {
        ctrl.currentForm = forms[0];
      }
    },

    getFormPreferences: function (channel, pref) {
      ctrl.preferences = new FormsFactory().restorePreferences(ctrl.currentForm.preferences);
      return ctrl.preferences[channel][pref] ? 'Yes' : 'No';
    },

    showRescheduleEvent: function () {
      return ctrl.model.type === 'private' && AuthService.hasPermission('EVENT_RESCHEDULE');
    },

    getOrderRequestId: function () {
      let r: TODO | false = false;
      angular.forEach(ctrl.orders, function (item) {
        if (item.orderRequestId) {
          r = item.orderRequestId;
        }
      });
      return r;
    },

    success: {
      getInstance: function (response) {
        const event = response.data.payload;

        event.oStartTime = event.startTime;
        event.oEndTime = event.endTime;
        event.startTime = CalendarService.parseDate(event.startTime);
        event.endTime = CalendarService.parseDate(event.endTime);
        ctrl.model = event;
        ctrl.safeDescription = $sce.trustAsHtml(ctrl.model.description);
        ctrl.updateHeader();

        if (ctrl.model.state && ctrl.model.state === 'cancelled') {
          ctrl.isCancelled = true;
          ctrl.formattedCancellationDate = $filter('date')(
            ctrl.model.cancellationDate,
            HelpersService.dateFormats.standardDateTime
          );
        } else if (ctrl.model.state && ctrl.model.state === 'suspended') {
          ctrl.isSuspended = true;
        }

        if (ctrl.model.priceList) {
          ctrl.model.priceList = TemplatesService.processSalesChannels(ctrl.model.priceList);
        }
        if (ctrl.hasPriceLists()) {
          ctrl.getPriceListName(ctrl.model.priceList.priceListId);
        }

        if (Array.isArray(ctrl.model.flexPays)) {
          for (let i = 0, ii = ctrl.model.flexPays.length; i < ii; i++) {
            ctrl.model.flexPays[i].formattedStartTime = $filter('date')(
              CalendarService.parseDate(ctrl.model.flexPays[i].startTime),
              UserPreferencesService.getDateFormat('standardTime', 'hourFormat')
            );
            ctrl.model.flexPays[i].formattedEndTime = $filter('date')(
              CalendarService.parseDate(ctrl.model.flexPays[i].endTime),
              UserPreferencesService.getDateFormat('standardTime', 'hourFormat')
            );
            if (ctrl.model.flexPays[i].type === 'discount') {
              ctrl.model.flexPays[i].discountCode = ctrl.findDiscount(ctrl.model.flexPays[i].discountId);
            }
          }
        }

        ctrl.hasAppliedAddOns =
          ctrl.model.addOns != null &&
          ctrl.model.addOns.inventoryAddOns != null &&
          Array.isArray(ctrl.model.addOns.inventoryAddOns) &&
          ctrl.model.addOns.inventoryAddOns.length > 0;
      },

      getDiscounts: function (response) {
        ctrl.discountCodes = response.data.payload.list;
      },

      getOrders: function (response) {
        ctrl.orders = response.data.payload.map(function (item) {
          item.createdOnDisplay = $filter('date')(CalendarService.parseDate(item.createdOn), ctrl.ordersDateFormat);
          return item;
        });

        if (ctrl.model.type === 'private' && !ctrl.model.orderRequestId) {
          ctrl.model.orderRequestId = ctrl.getOrderRequestId();
        }
      },

      getResourceRequests: function (response) {
        ctrl.resourcesList = response.data.payload.list;
      },

      getPublishedEventTemplate: function (response) {
        ctrl.templateName = response.data.payload.name || ctrl.model.originalFields.name;
      },

      getEntity: function (response) {
        ctrl.entity = ctrl.findOwner(response.data.payload);
        if (ctrl.entity) {
          ctrl.isUserEvent = true;
        }
      },

      getPriceListName: function (response) {
        const responsePriceList = response.data.payload;

        ctrl.priceListName = responsePriceList.name;

        if (
          !angular.equals(
            ctrl.getPriceListMap(responsePriceList.prices),
            ctrl.getPriceListMap(ctrl.model.priceList.prices)
          )
        ) {
          ctrl.isPriceListEdited = true;
        }
      },

      rescheduleEvent: function (response) {
        const rescheduledEvent = response.data.payload;

        ctrl.model.startTime = rescheduledEvent.startTime;
        ctrl.model.endTime = rescheduledEvent.endTime;
      },
    },

    // TODO: Implement error states
    error: {
      getInstance: function (response) {},
      getEntity: function (response) {},
      getOrders: function (response) {},
      getResourceRequests: function (response) {
        ctrl.notice.showErrorMessages([{ message: response.data.error }], { duration: 3000 });
      },
      getDiscounts: function (response) {},
      getPublishedEventTemplate: function (response) {
        ctrl.templateName = ctrl.model.originalFields.name;
      },
      getPriceListName: function (response) {},
      rescheduleEvent: function (response) {},
    },

    hasModelResources: function () {
      return ctrl.model.resources && ctrl.model.resources.length > 0;
    },

    hasOrders: function () {
      return ctrl.orders.length > 0;
    },

    onFormsOpen: function () {
      ctrl.showForm(ctrl.model.orderForms);
    },

    onCurrentTabChanged: function (n, o) {
      if (n && n !== o) {
        const callback = 'on' + HelpersService.cap(n) + 'Open';
        if (ctrl.hasOwnProperty(callback)) {
          ctrl[callback]();
        }
        if (n === 'forms') {
          ctrl.onFormsOpen();
        }
      }
    },
  };

  $scope.ordersGridOptions = {
    enableRowSelection: false,
    multiSelect: false,
    pageSize: 50,
    paginate: true,
    showFooter: false,
    enableGridMenu: true,
    columnDefs: [
      {
        field: 'orderNumber',
        displayName: 'Order no.',
      },
      {
        field: 'organizationName',
        displayName: 'Organization',
      },
      {
        field: 'email',
        displayName: 'Email',
      },
      {
        field: 'contactFirstName',
        displayName: 'First Name',
      },
      {
        field: 'contactLastName',
        displayName: 'Last Name',
      },
      {
        field: 'saleChannel',
        displayName: 'Sale Channel',
      },
      {
        field: 'checkInStatus',
        displayName: 'Checkin Status',
      },
      {
        field: 'createdOnDisplay',
        displayName: 'Time of purchase',
      },
      {
        field: 'totalAmount',
        displayName: 'Order total',
        cellFilter: 'currency',
      },
    ],
  };

  $scope.pricingGridOptions = {
    enableRowSelection: false,
    paginate: false,
    multiSelect: false,
    showFooter: false,

    columnDefs: [
      {
        field: 'personType.displayOrder',
        displayName: 'Order',
        visible: false,
      },
      {
        field: 'personType.name',
        displayName: 'Ticket Type',
      },
      {
        field: 'personType.description',
        displayName: 'Description',
      },
      {
        field: 'price',
        displayName: 'Price',
        cellFilter: 'currency',
      },
      {
        field: 'personType.active',
        displayName: 'Status',
        cellTemplate: `<div class="ui-grid-cell-contents" data-ng-class="col.colIndex()"><span data-ng-if="COL_FIELD">Live</span><span data-ng-if="!COL_FIELD">Deactivated</span></div>`,
      },
      {
        field: 'salesChannels[0].enabled',
        displayName: 'Web',
        cellTemplate: `<div class="ui-grid-cell-contents" data-ng-class="col.colIndex()"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>`,
      },
      {
        field: 'salesChannels[1].enabled',
        displayName: 'POS',
        cellTemplate: `<div class="ui-grid-cell-contents" data-ng-class="col.colIndex()"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>`,
      },
      {
        field: 'salesChannels[2].enabled',
        displayName: 'Reseller',
        cellTemplate: `<div class="ui-grid-cell-contents" data-ng-class="col.colIndex()"><span data-ng-class="{ inactive: grid.appScope.programsDetailOverview.restrictMembers }" data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>`,
      },
      {
        field: 'salesChannels[3].enabled',
        displayName: 'Customer Rep.',
        cellTemplate: `<div class="ui-grid-cell-contents" data-ng-class="col.colIndex()"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>`,
      },
      {
        field: 'salesChannels[5].enabled',
        displayName: 'Kiosk',
        cellTemplate: `<div class="ui-grid-cell-contents" data-ng-class="col.colIndex()"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>`,
      },
    ],
  };

  $scope.resourcesGridOptions = {
    enableRowSelection: false,
    paginate: false,
    multiSelect: false,
    showFooter: false,

    columnDefs: [
      {
        field: 'timeSlot',
        displayName: 'Time',
      },
      {
        field: 'eventScheduleDisplayName',
        displayName: 'Event Schedule',
      },
      {
        field: 'resourceTemplateName',
        displayName: 'Request For',
      },
      {
        field: 'assigned',
        displayName: 'Assigned To',
        onCellNavClick: function (row, col) {
          $scope.appScopeProvider.assign(row.entity);
        },
        cellTemplate: `<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.assign(row.entity)"><span data-ng-show="row.entity.resourceId">{{ row.entity.resourceName }}</span><span data-ng-show="!row.entity.resourceId">Assign</span></a></div>`,
      },
      {
        field: 'notes',
        displayName: 'Notes',
      },
    ],
  };

  $scope.programsInstance = ctrl;
  ctrl.init();

  $scope.appScopeProvider = {
    assign: ctrl.assign,
  };
}

export const ProgramsInstanceControllerModule = angular
  .module('acme.view.application.programs.instance.controllers', [
    uiRouter,
    'ui.grid',
    'acme.common.service.api',
    'acme.common.service.auth',
    'acme.common.service.calendar',
    'acme.common.service.helpers',
    'acme.common.service.templates',
    'acme.common.service.templates.helpers',
    'acme.common.service.userPreferences',
    'acme.common.service.themesHelper',
    FactoryFormsModule,
    'acme.common.factory.notice',
    'acme.common.factory.gridState',
    'acme.view.application.programs.instance.edit.resources.controllers',
  ])
  .controller('ProgramsInstanceController', ProgramsInstanceController).name;
